/**
 * Pattern sorting and label helpers — shared between InsightsDashboard
 * (Profile page) and AiReviewDialog (Review page) so both views show the
 * same predictable order and badge labels.
 *
 * Both sorters use trades desc as primary (more samples = stronger signal),
 * then winRate as tiebreaker. The winRate direction is asymmetric on purpose:
 *   - success: winRate desc — best wins surface first ("best of best")
 *   - avoid:   winRate asc  — worst losses surface first ("worst of worst")
 */

export const sortSuccessPatterns = (patterns) => {
  if (!Array.isArray(patterns)) return [];
  return [...patterns].sort((a, b) => {
    const tradesDiff = (b.trades || 0) - (a.trades || 0);
    if (tradesDiff !== 0) return tradesDiff;
    return (b.winRate || 0) - (a.winRate || 0);
  });
};

export const sortAvoidPatterns = (patterns) => {
  if (!Array.isArray(patterns)) return [];
  return [...patterns].sort((a, b) => {
    const tradesDiff = (b.trades || 0) - (a.trades || 0);
    if (tradesDiff !== 0) return tradesDiff;
    return (a.winRate || 0) - (b.winRate || 0);
  });
};

/**
 * "gap-go" → "Gap-Go", "momentum-fade" → "Momentum-Fade"
 * Used to render the category badge label.
 */
export const capitalizeCategory = (cat) => {
  if (!cat) return '';
  return cat
    .split('-')
    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
    .join('-');
};

/**
 * "core" → "Core". Falls back to "Emerging" for null/undefined input,
 * matching the backend PatternTierService null-safe contract.
 */
export const capitalizeTier = (tier) => {
  if (!tier) return 'Emerging';
  return tier.charAt(0).toUpperCase() + tier.slice(1);
};
